import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SharedService } from '@shared/services/shared.service';
import { IAdministrativeComplaintView, IResponseLettersView } from 'app/models/mainMenu/mainMenu';
import { ComplaintService } from 'app/services/complaint/complaint.service';
import { MainMenuService } from 'app/services/mainMenu/mainMenu.service';

@Component({
  selector: 'app-mainMenu-businessResponse',
  templateUrl: './businessResponse.component.html',
  styleUrls: ['./businessResponse.component.scss']
})

export class BusinessResponseComponent implements OnInit {
  @Input() countyId: string = '';
  businessResponseList: IResponseLettersView[] = [];

  displayedColumns: string[] = ['complaintId', 'complaintDate', 'businessName', 'address', 'city', 'zipCode',
    'generatedDateString', 'sentDateString'];
  dataSource = new MatTableDataSource<IResponseLettersView>(this.businessResponseList);

  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  constructor(public mainMenu: MainMenuService,
    public complaintService: ComplaintService,
    private sharedService: SharedService,
    public datePipe: DatePipe
  ) { }

  ngOnInit(): void {
    // Initial Business Response Letters
    this.mainMenu.getInitialResponseLetters(this.countyId).subscribe({
      next: response => {
        this.mainMenu.businessResponseList = response;
        this.dataSource.data = this.mainMenu.businessResponseList;
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      },
      error: e => {
        this.sharedService.toastr.error("Could not get business response.");
      },
    });

  }

  rowClick(row: any) {
  }

  gotoComplaint(compId: string) {
    this.complaintService.complaintId = +compId;
    this.complaintService.complaintTab = 3;
    this.sharedService.doRedirect('complaint/complaint/' + compId);
  }

}
